import { Component, ElementRef, EventEmitter, HostListener, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LsInputComponent } from '../ls-input/ls-input.component';
import { SelectOptionModel } from './models/select-option.model';

@Component({
  selector: 'ls-select',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './ls-select.component.html',
  styleUrls: ['./ls-select.component.scss']
})
export class LsSelectComponent extends LsInputComponent {
  @ViewChild('selectcontainer') selectcontainer!: ElementRef;
  @Input() override inputId: string = 'select';
  @Input() inputName: string = 'select-name';
  @Input() allowEmpty: boolean = false;
  @Input() label: string = '';
  @Input() width: string = '';
  @Input() errorMessage: string = '';
  @Input() dropdownPopoverShow = false;
  @Input() placeholder: string = '';
  @Input() selectlistboxlabel: string = '';
  @Input() selectSize: 'sm' | 'md' | 'lg' | 'input-sm' = 'sm';
  @Input() options: SelectOptionModel[] = [];
  @Input() selected: SelectOptionModel = { value: '', name: '' };
  @Input() isFiltered: boolean = false;
  @Input() dropdownMode: 'popover' | 'pushdown' = 'popover';

  filteredOptions: SelectOptionModel[] = [];
  filterText: string = '';

  @Output() onSelect = new EventEmitter<SelectOptionModel>();

  constructor(renderer: Renderer2) {
    super(renderer);
  }

  ngOnChanges() {
    this.filteredOptions = this.options;
    if (this.selected) {
      this.filterText = this.selected.name;
    }
  }

  toggleDropdown(): void {
    this.dropdownPopoverShow = !this.dropdownPopoverShow;
    this.placeholder = '';
  }

  showDropdown(): void {
    this.dropdownPopoverShow = true;
  }

  @HostListener('document:click', ['$event.target'])
  clickedOut(target: EventTarget | null): void {
    const clickInside = this.selectcontainer?.nativeElement.contains(target);
    if (!clickInside) {
      this.dropdownPopoverShow = false;
    }
  }

  isDisabled(option: SelectOptionModel): boolean {
    return option.disabled ?? false;
  }

  select(event: Event, option: SelectOptionModel): void {
    event.stopPropagation();

    if (!option.disabled) {
      this.selected = option;
      this.toggleDropdown();

      const control = this.group.controls[this.controlName];
      control.setValue(option.name);
      control.markAsTouched();

      this.filterText = option.name;
      this.onSelect.emit(option);
    }
  }

  filter() {
    if (this.filterText.length >= 1) {
      this.filteredOptions = this.options.filter((x) =>
        x.name.toLocaleLowerCase().includes(this.filterText.toLocaleLowerCase())
      );
    } else {
      this.filteredOptions = this.options;
    }
  }
}
